<template>
    <div>
        <div class="card float-left width100">

            <div class="card float-left width100">
                <div class="float-left width100 !mt-[80px]">
                    <div class="formElements">
                        <div class="">
                            <h5 class="messagePage">Select Appointment Date and Time</h5>
                            <div class="minSchedulerHeight">
                                <div class="px-10 maxWidthgrid mx-auto text-left">
                                    <div class="grid flex ">
                                        <div class="col-6" v-if="range && range.length > 0">
                                            <p>Select your preferred date</p>
                                        </div>
                                        <div class="col-6" v-if="slotsForSelectedDate.length > 0">
                                            <p>Select your preferred time</p>
                                        </div>
                                    </div>

                                    <div class="grid">
                                        <div class="p-col-12 p-md-6" v-if="range && range.length > 0">
                                            <div class="calenderControl timeDataHolder">
                                                <vc-date-picker v-model="selectedDate" is-inline
                                                    :attributes="calendarAttributes" :disabled-dates="disabledItems"
                                                    :masks="customMasks" mode="date" :min-date="today"
                                                    :first-day-of-week="0" />

                                            </div>
                                            <div class="flex flex-col gap-2 mt-4 slotDataStyle">
                                                <div class="flex items-center gap-2">
                                                    <span class="h-6 rounded-sm selectedslot slotdatawidth"></span>
                                                    <span>Selected</span>
                                                </div>
                                                <div class="flex items-center gap-2">
                                                    <span class="h-6 rounded-sm availableslot slotdatawidth"></span>
                                                    <span>Available</span>
                                                </div>
                                                <div class="flex items-center gap-2">
                                                    <span class="h-6 rounded-sm appointmentfull slotdatawidth"></span>
                                                    <span>Appointment Full</span>
                                                </div>
                                                <div class="flex items-center gap-2">
                                                    <span class="h-6 rounded-sm notavialableslot slotdatawidth"></span>
                                                    <span>Not Available</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="p-col-12 p-md-6 timeDataHolder mt-2"
                                            v-if="slotsForSelectedDate.length > 0">
                                            <div class="marginLeftTime">
                                                <div class="text-center p-3 border-round-sm">
                                                    {{ formatDateToString(selectedDate) }}
                                                </div>
                                                <div v-if="slotsForSelectedDate.length > 0"
                                                    class="mt-1 grid grid-cols-2 gap-2 slotdata"
                                                    style="max-height: 300px; overflow-y: auto;">
                                                    <div v-for="(slot, index) in slotsForSelectedDate"
                                                        :disabled="slot.isBooked || slot.isBlocked" :key="index"
                                                        @click="!isPastSlot(slot) && selectSlot(slot, index)" :class="[
                                                            'p-1 text-center cursor-pointer slotStyle max-width',
                                                            isPastSlot(slot) ? 'opacity-50 cursor-not-allowed' :
                                                                index === currentSlot ? 'selected' :
                                                                    index !== currentSlot ? 'hover:bg-[#3e50a0]' : '',
                                                            {
                                                                'notAvailable': slot.isBooked,
                                                                'blokedSlot': slot.isBlocked,
                                                                'originallyBooked': slot.isOriginallySelected
                                                            }
                                                        ]">
                                                        {{ apptTime(slot.startTime) }}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="buttonContainer marginTopButton">
                                <div class="p-grid">
                                    <div class="p-col-12">
                                        <div class="float-Left">
                                            <Button type="button" label="< Back" @click="onBack()"
                                                class="linkBtn customLinkCss" />
                                        </div>
                                        <div class="float-Right">
                                            <Button type="submit" tabindex="16" label="Next" @click="onNext()"
                                                class="btn p-button-raised" :disabled="!currentSlot && iscurrentSlot" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onBeforeMount, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useApiService } from '@/utils/useApiService'
import { format, parseISO } from 'date-fns'
import { useNotifications } from '@/utils/useNotifications'
//import { defineEmits } from 'vue'

const emit = defineEmits(['backClick', 'nextClick'])
const { notifyError } = useNotifications()
const { fetchWrapperForGet, fetchWrapperForPut } = useApiService()
const store = useStore()
const router = useRouter()

const id = ref('')
const range = ref([])
const limit = ref(1)
const ccOfficerId = ref('')
const serviceDetails = ref({})
const slotData = ref([])
const selectedDate = ref(null)
const scheduleInfo = ref({ appointmentDate: new Date(), startTime: '' })
let storeInfo = reactive()
const currentSlot = ref(null)
const previousSlot = ref(null)
const selectedSlot = ref(null)

function formatDateToDDMMYYYY(date) {
    const d = new Date(date)
    const day = String(d.getDate()).padStart(2, '0')
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const year = d.getFullYear()
    return `${day}-${month}-${year}`
}

// const formatDate = (dateStr) => format(new Date(dateStr), 'yyyy-MM-dd')
const formatDate = (dateStr) => {
    const date = new Date(dateStr)
    if (isNaN(date.getTime())) {
        return '' 
    }
    return format(date, 'yyyy-MM-dd')
}

// const slotsForSelectedDate = computed(() => {
//     if (!selectedDate.value) return []
//     const formatted = format(selectedDate.value, 'yyyy-MM-dd')
//     const day = slotData.value.find(d => formatDate(d.date) === formatted)
//     return day?.appointmentSlots || []
// })
const slotsForSelectedDate = computed(() => {
    if (!selectedDate.value) return []

    const selected = new Date(selectedDate.value)
    if (isNaN(selected.getTime())) return []

    const formatted = format(selected, 'yyyy-MM-dd')

    const day = slotData.value.find(d => {
        const date = new Date(d.date)
        if (isNaN(date.getTime())) return false
        return format(date, 'yyyy-MM-dd') === formatted
    })

    return day?.appointmentSlots || []
})
function formatDateToString(date) {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = d.toLocaleString('default', { month: 'long' });
    const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
    const year = d.getFullYear();
    return `${day}-${capitalizedMonth}-${year}`;
}
let iscurrentSlot = reactive(true)

function selectSlot(slot, index) {
    slotsForSelectedDate.value.forEach(s => (s.isSelected = false))
    slot.isSelected = true
    selectedSlot.value = slot
    if (currentSlot.value !== index) {
        previousSlot.value = currentSlot.value
        if (index === 0) {
            iscurrentSlot = false
            currentSlot.value = index
        } else {
            currentSlot.value = index
        }

    }
    let slotdata = {
        ...slot,
        index: index
    }
    store.commit('setselectedSlot', slotdata)
}
function isPastSlot(slot) {
    const slotDate = new Date(selectedDate.value)
    const [h, m] = slot.startTime.split(':')
    slotDate.setHours(+h, +m, 0, 0)
    const now = new Date()
    const isToday = selectedDate.value.toDateString() === now.toDateString()
    return isToday && slotDate < now
}

function getSchedule() {
    fetchWrapperForGet(`api/mopsessions/appointmentschedule`, false, false).then(data => {
        if (!data) return

        data.forEach(value => {
            const [yyyy, mm, dd] = value.date.split('T')[0].split('-')
            value.date = new Date(yyyy, mm - 1, dd)
        })
        range.value = data
        slotData.value = data
        selectedDate.value = new Date(scheduleInfo.value.appointmentDate)
        setTimeout(() => {
            const formatted = formatDate(scheduleInfo.value.appointmentDate)
            const dayData = slotData.value.find(d => formatDate(d.date) === formatted)

            if (dayData && dayData.appointmentSlots) {
                const index = dayData.appointmentSlots.findIndex(slot =>
                    slot.startTime === scheduleInfo.value.startTime &&
                    slot.endTime === scheduleInfo.value.endTime
                )
                if (index !== -1) {
                    const slot = dayData.appointmentSlots[index]
                    slot.isSelected = true
                    selectedSlot.value = slot
                    currentSlot.value = index
                    if(index === 0){
                        iscurrentSlot=false
                    }
                    store.commit('setselectedSlot', selectedSlot.value)
                }
            }
        }, 0)
    })
}

function updateStore(data) {
    const model = {
        appointmentDate: data.appointmentDate,
        startTime: data.startTime,
        endTime: data.endTime
    }
    store.dispatch('setScheduleInfo', model).then(() => {
        router.push({ path: `/contactdetails` })
    })
}


const appointmentStore = store.getters.getNewAppointment
function onNext() {
    const selectedDateObj = range.value.find(x => x.isSelected) || selectedSlot.value.startTime

    if (!selectedDateObj) {
        notifyError('Please select a slot before proceeding.')
        return
    }
    if (!selectedDateObj) {
        notifyError('Please select at least one time slot.')
        return
    }
    const model = {
        serviceId: storeInfo.serviceId,
        appointmentDate: selectedDate.value,
        AppointmentDateAsString: format(selectedDate.value, 'dd-MM-yyyy'),
        startTime: selectedSlot.value.startTime,
        endTime: selectedSlot.value.endTime,
        numberOfSlots: 1,
        id: id.value
    }
    let appinfo = {
        ...appointmentStore,
        startTime: selectedSlot.value.startTime,
        endTime: selectedSlot.value.endTime,
        appointmentDate: selectedDate.value,
        AppointmentDateAsString: selectedDate.value,
        numberOfSlots: 1,
        id: id.value
    }
    fetchWrapperForPut(
        `api/mopsessions/schedule`, model, false, true, true
    ).then(data => {
        if (data[0]?.appointment?.length === 0) {
            emit('nextClick')
            store.dispatch('setMopAppointmentDetails', appinfo);
            store.dispatch('setNewAppointMent', appinfo);
        } else {
            store.dispatch('setMopAppointmentDetails', appinfo);
            store.dispatch('setNewAppointMent', appinfo);
            emit('nextClick')
        }
    })
}
function toFixedUTCDate(dateStr, hour = 18, minute = 30) {
    const date = new Date(dateStr);
    date.setUTCHours(hour, minute, 0, 0);
    date.setUTCDate(date.getUTCDate() - 1);
    return date.toISOString().split('.')[0] + '.000Z';
}
function onBack() {
    emit('backClick')
}



const calendarAttributes = computed(() => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const isSameDay = (date1, date2) => {
        return date1.getFullYear() === date2.getFullYear()
            && date1.getMonth() === date2.getMonth()
            && date1.getDate() === date2.getDate()
    }

    const isTodaySelected = isSameDay(today, new Date(selectedDate.value))

    const baseAttributes = slotData?.value.map(d => {
        const date = new Date(d.date)
        date.setHours(0, 0, 0, 0)

        let type = 'notAvailable'

        if (date < today) {
            type = 'notAvailable'
        } else {
            const hasAvailable = d.appointmentSlots?.some(slot =>
                !slot.isBlocked && !slot.isBooked && !slot.isReserved
            )
            type = hasAvailable ? 'available' : 'notAvailable'
        }

        return {
            key: `${type}-${date.toDateString()}`,
            dates: date,
            highlight: {
                class: type === 'available' ? 'available-slot' : 'not-available-slot',
                contentClass: type === 'available' ? 'available-slot-text' : 'not-available-slot-text'
            }
        }
    }) || []

    baseAttributes.push({
        key: 'selected-date',
        dates: selectedDate.value,
        highlight: {
            class: 'selected-slot',
            contentClass: 'selected-slot-text'
        }
    })

    slotData?.value.forEach(d => {
        const date = new Date(d.date)
        date.setHours(0, 0, 0, 0)

        if (d.isBooked && d.isBlocked) {
            baseAttributes.push({
                key: `booked-${date.toDateString()}`,
                dates: date,
                highlight: {
                    class: 'bothblockedandbook',
                    contentClass: 'booked-slot-both'
                }
            })
        } else if (d.isBooked) {
            baseAttributes.push({
                key: `booked-${date.toDateString()}`,
                dates: date,
                highlight: {
                    class: 'booked',
                    contentClass: 'booked-slot-text'
                }
            })
        }
    })

    baseAttributes.push({
        key: 'today',
        dates: today,
        highlight: {
            class: isTodaySelected ? 'today-slot-selected' : 'today-slot-unselected',
            contentClass: isTodaySelected ? 'today-slot-text-selected' : 'today-slot-text-unselected'
        }
    })

    return baseAttributes
})




function apptTime(value) {
    if (value) {
        const [hours, minutes, seconds] = value.split(':').map(Number);
        const date = new Date();
        date.setHours(hours, minutes, seconds || 0);

        let hour = date.getHours();
        const minute = date.getMinutes();
        const ampm = hour >= 12 ? 'PM' : 'AM';

        hour = hour % 12;
        hour = hour ? hour : 12; // the hour '0' should be '12'

        const minuteStr = minute < 10 ? '0' + minute : minute;
        return `${hour}:${minuteStr} ${ampm}`;
    }
    return value;
}
const today = new Date()
today.setHours(0, 0, 0, 0)

const endDate = new Date(today)
endDate.setDate(endDate.getDate() - 1)
const disabledItems = computed(() => {
    const noSelectable = []
    for (let i = 0; i < slotData.value.length; i++) {
        const item = slotData.value[i]
        if (item.isBooked || item.isBlocked) {
            noSelectable.push(new Date(item.date))
        }
    }
    return noSelectable
})
const customMasks = {
    weekdays: 'WW'
}

onBeforeMount(() => {
    id.value = store.getters.getAppointmentId
    storeInfo = store.getters.getNewAppointment
    storeInfo.appointmentDate = new Date(storeInfo.appointmentDate)
    scheduleInfo.value = storeInfo
    getSchedule()
})
</script>

<style lang="css" scoped>
.slotStyle {
    width: 33%;
    background: #fecd20;
    line-height: 20px;
    color: black !important;
    font-size: 13px !important;
    margin: 2px 0 0 0 !important;
}

.vc-day-content.vc-disabled {
    background-color: #eee !important;
    color: #aaa !important;
    border-radius: 50%;
}


::v-deep(.vc-highlight.vc-day-box-center-center.available-slot) {
    background-color: #fecd20 !important;
    border-radius: 0 !important;
    width: 100% !important;
    height: 36px !important;
    margin: 10px auto;
}



::v-deep(.vc-day-content .available-slot-text) {
    color: #000 !important;
    font-weight: bold;
}

::v-deep(.vc-highlight.not-available-slot) {
    background-color: #e6e6e6 !important;
    border-radius: 0 !important;
    width: 100% !important;
    padding: 18px 40px !important;
    cursor: default !important;
    pointer-events: none !important;
    opacity: 0.5 !important;
}



.vc-day-content:hover {
    background-color: transparent !important;
}

.calenderControl {
    margin-right: 30px;
}



.slotdata {
    display: flex !important;
    justify-content: center !important;
}

.selected {
    background-color: #3e50a0 !important;
    color: #ffff !important;
}

.messagePage {
    font-weight: 900;
    margin: 60px 0 10px 0;
    font-size: 18px;
}

.slotDataStyle {
    display: flex !important;
    flex-direction: column !important;
}

.slotdatawidth {
    width: 20px !important;
}

.timeDataHolder {
    border: 1px solid #a6a6a6;
    padding: 10px;
    border-radius: 5px;
    height: 396px;
    overflow: hidden;
}

.marginLeftTime {
    margin-left: 30px;
}

.opacity-50 {
    opacity: 0.5;
}



.formElements {
    float: left;
    width: 100%;
    margin-top: 53px;
}

.selected-slot-text {
    background-color: #1565c0 !important;
    color: white !important;
    border-radius: 0 !important;
}


.available-slot-text {
    background-color: #ffca28 !important;
    /* Amber Yellow */
    color: black !important;
    border-radius: 0 !important;
}


.not-available-slot-text {
    background-color: #e6e6e6 !important;

    color: #999 !important;
    border-radius: 0 !important;
}


.vc-day.vc-disabled .vc-day-content {
    background-color: #f5f5f5 !important;
    color: #ccc !important;
    border-radius: 0 !important;
}

.notAvailable {
    background-color: darkorange !important;
    pointer-events: none !important;
    color: #ffff !important;
}

.blokedSlot {
    background-color: #e6e6e6 !important;
    pointer-events: none !important;
    opacity: 0.5 !important;
    color: #848484;
}
</style>